import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import UriUtils from '../modules/UriUtils';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const PaymentGatewayService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}/payment-gateway`;

  const managedpay = {
    searchScheduledInstallmentPlans: (criteria) => {
      const { authentication, } = store.getState().auth;
      const headers = {};
      headers.Authorization = authentication.token;
      headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

      const queryString = UriUtils.toQueryString(criteria);
      return axios.get(`${BASE_URL}/managedpay/search${queryString}`, {
        headers,
      });
    },
    cancelInstallmentPlan: (criteria) => {
      const { authentication, } = store.getState().auth;
      const headers = {};
      headers.Authorization = authentication.token;
      headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

      const queryString = UriUtils.toQueryString(criteria);
      return axios.delete(`${BASE_URL}/managedpay/delete${queryString}`, {
        headers,
      });
    },
  };

  const paymentAccount = {
    getPaymentAccountById: (criteria) => {
      const { authentication, } = store.getState().auth;
      const headers = {};
      headers.Authorization = authentication.token;
      headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

      const queryString = UriUtils.toQueryString(criteria);
      return axios.get(`${BASE_URL}/payment-account${queryString}`, {
        headers,
      });
    },
  };

  const paymentAccounts = {
    getPaymentAccountsByCustomerId: (customerId) => {
      const { authentication, } = store.getState().auth;
      const headers = {};
      headers.Authorization = authentication.token;
      headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

      return axios.get(`${BASE_URL}/customers/${customerId}`, {
        headers,
      });
    },
  };

  const refund = {
    getRefundReasons: () => {
      const { authentication, } = store.getState().auth;
      const headers = {};
      headers.Authorization = authentication.token;
      headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

      return axios.get(`${BASE_URL}/refund-reasons`, {
        headers,
      });
    },
  };

  service.managedpay = managedpay;
  service.paymentAccount = paymentAccount;
  service.paymentAccounts = paymentAccounts;
  service.refund = refund;

  return service;
})();

export default PaymentGatewayService;
